import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import styles from "./OurServices.module.css";

const OurServices = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerId } = useParams();

  const { customerName, customerEmail, customerPhone } = location.state || {};

  const goStringing = () => {
    if (!customerId) {
      navigate("/dashboard/manage-customer");
      return;
    }
    navigate(`/dashboard/customer/service-details/${customerId}`, {
      state: { customerName },
    });
  };

  const goGrip = () => {
    if (!customerId) {
      navigate("/dashboard/manage-customer");
      return;
    }
    navigate("/dashboard/grip-booking-form", {
      state: {
        customerId,
        customerName,
        bookingDate: new Date().toISOString().split("T")[0],
        instoreLocation: null,
        presetGripType: null,
      },
    });
  };

  const goBack = () => {
    if (customerId) {
      navigate(`/dashboard/customer-details`, {
        state: { customerName, customerEmail, customerPhone },
      });
    } else {
      navigate("/dashboard/manage-customer");
    }
  };

  return (
    <div className={styles.full}>
      <header className={styles.header}>
        <h1 className={styles.pageHeading}>
          Book a Service for {customerName || "Customer"}
        </h1>
      </header>

      <main className={styles.main}>
        <div className={styles.card}>
          <h2 className={styles.title}>Service Selection</h2>
          <p className={styles.subtitle}>
            Choose between racket stringing or grip replacement.
          </p>

          <div className={styles.servicesGrid}>
            <button
              type="button"
              className={styles.serviceCard}
              onClick={goStringing}
              data-info="Fast & reliable racket stringing"
            >
              <h3>Stringing Services</h3>
              <p>Professional racket stringing with quality strings</p>
            </button>

            <button
              type="button"
              className={styles.serviceCard}
              onClick={goGrip}
              data-info="Base grips & overgrips"
            >
              <h3>Grip Services</h3>
              <p>Replacement grips & overgrips</p>
            </button>
          </div>

          <div className={styles.actions}>
            <button className={styles.btnGhost} onClick={goBack}>
              ← Back to Customer Details
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OurServices;
